import { allServiceRequestStates } from "constants/Constants"
import { getServiceDetails } from "extensions/usoc/api/service"
import { useMemo } from "react"
import { useSelector } from "react-redux"
import useSWR from "swr"
import { getDateParams, splitDateRange } from "utils/date"
import { isAnyAPIFailed } from "utils/nodata"
import { batchAPICalls, retryFailedRequests } from "utils/retryFailedRequests"

import useExtension from "./useExtension"
import useUserAuth from "./useUserAuth"

// async function fetchServiceDetails(auth, extension, projectId, params) {
//   const host = extension?.config?.env?.clientApiGateway?.URL
//   const results = []
//   for (const param of params) {
//     const result = await retryFailedRequests({ auth, host }, projectId, param, getServiceDetails)
//     results.push(result)

//   }
//   return results
// }

export default function ({
  dateRangeFilter,
  condition = true,
  stateFilter = allServiceRequestStates
}) {
  const auth = useUserAuth()
  const extension = useExtension()

  const projectID = useSelector((state) => {
    return state.settings.currentProject
  })

  const dateRangeFilters = useMemo(() => {
    return Array.isArray(dateRangeFilter) ? dateRangeFilter : [dateRangeFilter]
  }, [dateRangeFilter])

  const dateRangeSegmentsArray = useMemo(() => {
    return dateRangeFilters.map((dateRangeFilter) =>
      splitDateRange(dateRangeFilter)
    )
  }, [dateRangeFilters])

  const serviceRequestParams = useMemo(() => {
    return dateRangeSegmentsArray
      .map((dateRangeSegments) =>
        dateRangeSegments.map(
          (dateRangeSegment) =>
            `state=${stateFilter || allServiceRequestStates}&${getDateParams(
              dateRangeSegment
            )}`
        )
      )
      .flat()
  }, [dateRangeSegmentsArray, stateFilter])

  const { data: serviceRequestResponses } = useSWR(
    () =>
      projectID && condition
        ? serviceRequestParams.map(
          (param) => `/projects/${projectID}/get_request_details?${param}`
        )
        : null,
    () => batchAPICalls(auth, extension, projectID, serviceRequestParams, getServiceDetails),
    { suspense: true }
  )

  const accountFilteredServiceRequestDetails = useMemo(() => {
    let i = 0
    return dateRangeSegmentsArray.map((dateRangeSegments) => {
      const slicedServiceRequestDetails =
        serviceRequestResponses?.slice(i, i + dateRangeSegments.length) || []
      i += dateRangeSegments.length
      return {
        data: slicedServiceRequestDetails
          ?.map((eachResponse) =>
            Array.isArray(eachResponse.data) ? eachResponse.data : []
          )
          .flat(),
        error: isAnyAPIFailed(slicedServiceRequestDetails)
      }
    })
  }, [serviceRequestResponses, dateRangeSegmentsArray])

  return Array.isArray(dateRangeFilter)
    ? accountFilteredServiceRequestDetails
    : accountFilteredServiceRequestDetails[0]
}
